import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const c = {
  cream: "#FFF8E7",
  ivory: "#FFFDF5",
  warmGold: "#F5D060",
  deepGold: "#D4A017",
  richRed: "#C0392B",
  flamenco: "#F05260",
  flamenco400: "#F47781",
  flamenco100: "#F7D9DC",
  skyfall: "#84D5F7",
  skyfall400: "#99DDF9",
  skyfall100: "#CBEFFF",
  mintleaf: "#4EB969",
  mintleaf400: "#69CB82",
  mintleaf300: "#91DFA5",
  plumwood: "#842885",
  plumwood400: "#B666B7",
  plumwood300: "#EA9BEB",
  white: "#FFFFFF",
  darkText: "#2B1810",
  medText: "#5C3D2E",
  stripe1: "#F05260",
  stripe2: "#FFF8E7",
  ticketBorder: "#D4A017",
};

export const nav: NavPalette = {
  surface: "rgba(255, 248, 231, 0.94)",
  surfaceHover: "rgba(255, 253, 245, 0.96)",
  border: "rgba(212, 160, 23, 0.55)",
  text: "#2B1810",
  textMuted: "rgba(92, 61, 46, 0.8)",
  activeBg: "rgba(245, 208, 96, 0.4)",
  activeText: "#C0392B",
};
